import React from 'react'
import styled from 'styled-components'
import defaultImg from '/static/images/image-placeholder.png'
import { tabletSize, mobileSize } from 'theme'

const BaseInfo = ({ sku, children }) => {
  const { name, subTitle, detailImageUrl } = sku
  return (
    <BaseInfoWapper>
      <ImageWapper>
        <CouponImage src={detailImageUrl || defaultImg} />
      </ImageWapper>
      <RightBaseInfo>
        <CardTitle>{name}</CardTitle>
        <SubTitle>{subTitle}</SubTitle>
        {children}
      </RightBaseInfo>
    </BaseInfoWapper>
  )
}

export const BaseInfoWapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  background: #fff;
  @media ${tabletSize} {
    flex-direction: column;
  }
  @media ${mobileSize} {
    border-radius: 0 0 8px 8px;
    padding: 16px 8px;
  }
`
export const ImageWapper = styled.div`
  width: 42%;
  height: 0;
  /* height = 42% * 56% ≈ 23.5% */
  padding-bottom: 23.5%;
  position: relative;
  @media ${tabletSize} {
    width: 100%;
    /* height = width * 56% */
    padding-bottom: 56%;
    margin-bottom: 24px;
  }
  @media ${mobileSize} {
    margin-bottom: 16px;
  }
`
const CouponImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  border-radius: 4px;
`
export const RightBaseInfo = styled.div`
  padding-left: 24px;
  width: 58%;
  box-sizing: border-box;
  @media ${tabletSize} {
    width: 100%;
    padding-left: 0;
  }
`
const CardTitle = styled.div`
  font-size: 24px;
  font-weight: 500;
  color: ${(p) => p.theme.color.navigationTitleColor};
  padding-bottom: 8px;
  line-height: 1.3;
  @media ${mobileSize} {
    font-size: 18px;
  }
`
const SubTitle = styled.div`
  font-size: 16px;
  color: ${(p) => p.theme.color.dark100};
  line-height: 1.5;
  margin-bottom: 14px;
  @media ${mobileSize} {
    font-size: 14px;
    margin-bottom: 8px;
  }
`
export default BaseInfo
